/*

OVERVIEW

attribute BE          | Translation                       | Translation key     | Render Type |
----------------------|-----------------------------------|---------------------|-------------|
heat_pump_energy      | Type Warmtepomp                   | heat_pump_type      | checkboxes  |
heating               | Vermogen Warmtepomp (7°C / 35°C)  | heat_pump_power     | dropdown    |
heat_pump_series      | Product Warmtepomp                | heat_pump_series    | checkboxes  |
kettle_type           | CV Ketel                          | kettle_type         | dropdown    |
kettle_series         | Product CV                        | kettle_series       | dropdown    |
cw_class              | CW klasse CV ketel                | cw_class_kettle     | dropdown    |
gas_connection_type   | Aansluiting rookgas               | gas_connection_type | dropdown    |

SCENARIOS

default (nothing selected)            ---> [heat_pump_energy, heat_pump_series, heating]
heat_pump_energy === 'Elektrisch'    ---> [heat_pump_energy, heat_pump_series, heating]
heat_pump_energy === 'Hybride'         ---> [heat_pump_energy, heat_pump_series, kettle_type, heating]
kettle_type === 'CV Handhaven'      ---> [heat_pump_energy, heat_pump_series, kettle_type, heating]
kettle_type === 'Nieuwe CV'          ---> [heat_pump_energy, heat_pump_series, kettle_type, kettle_series, heating, cw_class, gas_connection_type]

*/

export default {
  heat_pump_energy: {
    label: 'systems.filters.heat_pump_type',
    type: 'checkboxes',
  },
  heating: {
    label: 'systems.filters.heat_pump_power',
    type: 'dropdown',
  },
  heat_pump_series: {
    label: 'systems.filters.heat_pump_series',
    type: 'checkboxes',
  },
  kettle_type: {
    label: 'systems.filters.kettle_type',
    type: 'dropdown',
  },
  kettle_series: {
    label: 'systems.filters.kettle_series',
    type: 'dropdown',
  },
  cw_class: {
    label: 'systems.filters.cw_class_kettle',
    type: 'dropdown',
  },
  gas_connection_type: {
    label: 'systems.filters.gas_connection_type',
    type: 'dropdown',
  },
};



// WEBPACK FOOTER //
// ./js/utils/system-filters-config.js